module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ed-Fb-Gd.adef3e7f.png";